var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArithmeticOperators(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3 6 6 6 6 3 8 3 8 6 11 6 11 8 8 8 8 11 6 11 6 8 3 8 3 6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 16,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.54 19.12 19.12 20.54 17 18.41 14.88 20.54 13.46 19.12 15.59 17 13.46 14.88 14.88 13.46 17 15.59 19.12 13.46 20.54 14.88 18.41 17 20.54 19.12"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 10,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 8,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArithmeticOperators);
export default __webpack_public_path__ + "static/media/arithmetic_operators.a43ccbd6b5bd6bbf5ae385c7562caca7.svg";
export { ForwardRef as ReactComponent };